import { render, staticRenderFns } from "./ObservedTableDataToExport.vue?vue&type=template&id=eb6c9952&scoped=true"
import script from "./ObservedTableDataToExport.vue?vue&type=script&lang=js"
export * from "./ObservedTableDataToExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6c9952",
  null
  
)

export default component.exports